import { baseApi } from './baseApi';

export const rentalApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getRentals: builder.query({
      query: (params) => ({
        url: '/rentals',
        params,
      }),
      providesTags: ['Rentals'],
    }),
    getRentalById: builder.query({
      query: (id) => `/rentals/${id}`,
      providesTags: (result, error, id) => [{ type: 'Rentals', id }],
    }),
    createRental: builder.mutation({
      query: (data) => ({
        url: '/rentals',
        method: 'POST',
        body: data,
      }),
      invalidatesTags: ['Rentals'],
    }),
    returnRental: builder.mutation({
      query: ({ id, data }) => ({
        url: `/rentals/${id}/return`,
        method: 'POST',
        body: data,
      }),
      invalidatesTags: (result, error, { id }) => [{ type: 'Rentals', id }, 'Rentals'],
    }),
  }),
});

export const {
  useGetRentalsQuery,
  useGetRentalByIdQuery,
  useCreateRentalMutation,
  useReturnRentalMutation,
} = rentalApi;
